// run_body — la forme du corps d'une demande de run.
//
// ── POURQUOI UNE FONCTION, ET POURQUOI ELLE EST PURE ────────────────────────
//
// Cette décision vivait dans un ternaire au milieu de api.ts, gardée par un test qui
// comparait l'expression caractère pour caractère : il cassait à chaque reformulation sans
// rien prouver du comportement. La règle qu'il protégeait, elle, compte.
//
// LA RÈGLE : LE CORPS D'UNE DEMANDE ORDINAIRE NE GAGNE AUCUN CHAMP. C'est `{ prompt }` et
// rien d'autre, exactement comme avant les pièces jointes. Un `images: []` de plus, et c'est
// la circulation de tous les jours qui change de forme pour dire « rien ».
//
// ── CE QU'ELLE NE FAIT PAS ──────────────────────────────────────────────────
//
// Aucune borne, aucune coupure, aucun nettoyage. Les bornes font foi côté serveur
// (platform-service/lib/image_intake et lib/document_intake) et sont annoncées à
// l'utilisateur par le crochet. Couper un texte ICI le ferait en silence, et le modèle
// raisonnerait sur un document amputé sans le savoir — le serveur, lui, coupe ET le dit.

/** Un document joint, réduit à ce qui PART. Ce que le crochet porte d'autre (le type) reste
 *  dans le navigateur. */
export type RunDocument = { readonly name: string; readonly text: string };

export type RunAttachments = {
  readonly images?: readonly string[];
  readonly documents?: readonly RunDocument[];
};

export type RunBody = {
  readonly prompt: string;
  readonly images?: readonly string[];
  readonly documents?: readonly RunDocument[];
};

const nonVide = (l: readonly unknown[] | undefined): boolean => l !== undefined && l.length > 0;

/** PURE. Le corps à poster pour une demande écrite. */
export function runBody(prompt: string, joints?: RunAttachments): RunBody {
  return {
    prompt,
    ...(nonVide(joints?.images) ? { images: joints!.images } : {}),
    // RECOPIÉ CHAMP PAR CHAMP : l'objet du crochet peut porter d'autres champs, propres au
    // navigateur. Les envoyer ferait voyager des octets que le serveur ignore, à chaque
    // demande d'un run qui en fait trente.
    ...(nonVide(joints?.documents)
      ? { documents: joints!.documents!.map((d) => ({ name: d.name, text: d.text })) }
      : {}),
  };
}
